import { useTranslation } from 'react-i18next'

import { formatMoneyShort } from '@percent/utility'
import { useAuth, useMoneyFormat } from '@percent/workplace-giving/common/hooks'
import { useDonationWallet } from '@percent/workplace-giving/common/hooks/useDonationWallet/useDonationWallet'
import { DashboardMetricCard } from '@percent/workplace-giving/common/components/DashboardMetricCard/DashboardMetricCard'
import { ReactComponent as WalletIcon } from '@percent/workplace-giving/assets/icons/wallet.svg'
import { AppRoute } from '@percent/workplace-giving/routing/AppRoute.enum'
import {
  getAccountConfigFromAuthState,
  getPartnerFromAuthState
} from '@percent/workplace-giving/context/auth/authContextController/AuthContextController'

export function WalletBalanceCard(): JSX.Element {
  const {
    t,
    i18n: { language }
  } = useTranslation()
  const { data, isPending } = useDonationWallet()
  const { moneyFormat } = useMoneyFormat()
  const { state } = useAuth()
  const accountConfig = getAccountConfigFromAuthState(state)
  const partner = getPartnerFromAuthState(state)
  const currencyCode = accountConfig?.currency ?? partner?.currencyCode
  const balance = data?.balance ?? { amount: 0, currency: currencyCode ?? 'USD' }

  return (
    <DashboardMetricCard
      title={t('workplace_giving.sidePanel.walletBalance')}
      value={moneyFormat(balance)}
      compactValue={formatMoneyShort(balance, { locale: language, roundingMode: 'floor' })}
      isLoading={isPending}
      iconElement={<WalletIcon />}
      description={t('workplace_giving.sidePanel.walletBalanceDescription')}
      testId="wallet-balance-card"
      href={AppRoute.DONATE}
    />
  )
}
